import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'tog-simple-delete-list',
  templateUrl: './simple-delete-list.component.html',
  styleUrls: ['./simple-delete-list.component.scss']
})
export class SimpleDeleteListComponent implements OnInit {
  filtertext: string = '';
  @Input() elements: string[] = [];
  @Output('delete') delete = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  removeElement(el) {
    let index = this.elements.indexOf(el);
    this.delete.emit(index);
  }

  get filteredElements() {
    if (this.filtertext) {
      return this.elements.filter((el) => el.toLowerCase().indexOf(this.filtertext.toLowerCase()) > -1);
    } else return this.elements;
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/simple-delete-list/simple-delete-list.component.ts